import React from 'react';
import { motion } from 'framer-motion';
import { ClockIcon, ExternalLinkIcon, LockIcon, MailIcon, MapPinIcon, PartyPopperIcon } from 'lucide-react';
import { BadgeDivider } from './Badge';
type Show = {
  date: {
    weekday: string;
    monthDay: string;
  };
  time: string;
  venueName: string;
  venueUrl: string;
  mapUrl: string;
  city: string;
  thumbnail: string | null;
  markerBackingClass: string;
  markerLabel?: string;
  swatchClass: string;
  isPrivate?: boolean;
};
const TWISTED_TIKI_MAP_URL = 'https://www.google.com/maps/dir//340+Corey+Ave,+St.+Pete+Beach,+FL+33706';
const PERIDIA_MAP_URL = 'https://www.google.com/maps/dir//4950+Peridia+Blvd+E,+Bradenton,+FL+34203';
const AMERICAN_LEGION_MAP_URL = 'https://www.google.com/maps/dir//American+Legion+Post+273+-+Madeira+Beach,+600+American+Legion+Dr,+Madeira+Beach,+FL+33708/@27.7930931,-82.7455018,15z/data=!4m8!4m7!1m0!1m5!1m1!1s0x88c2fc6a316a0661:0x9d617182192c7085!2m2!1d-82.7951634!2d27.8096528?entry=ttu&g_ep=EgoyMDI2MDcxNS4wIKXMDSoASAFQAw%3D%3D';
const MASTRYS_MAP_URL = 'https://www.google.com/maps/dir//7701+Blind+Pass+Rd,+St.+Pete+Beach,+FL+33706';
const MASTRYS_LOGO = 'https://cdn.magicpatterns.com/uploads/fNUAr62f8PdsNMCQYhwHxz/logo-Mastrys.png';
const TWISTED_TIKI_LOGO = 'https://cdn.magicpatterns.com/uploads/nKMHg69DKAwqux1zav3jfG/Twisted2BTiki2Blogo2Bfloat2Bresized-1920w.webp';
const PERIDIA_LOGO = 'https://cdn.magicpatterns.com/uploads/i1DPYF4j9PYAVs6Ck6mpb3/Peridia_logo.webp';
const AMERICAN_LEGION_LOGO = 'https://cdn.magicpatterns.com/uploads/92p7X6AWgg7yVfxcUjyyMk/Am_Legion_273.png';
const SHOWS: Show[] = [{
  date: {
    weekday: 'Fri',
    monthDay: 'Sep 25'
  },
  time: '~6–9 PM',
  venueName: 'Private Event',
  venueUrl: '',
  mapUrl: '',
  city: '',
  thumbnail: null,
  markerBackingClass: '',
  swatchClass: '',
  isPrivate: true
}, {
  date: {
    weekday: 'Sun',
    monthDay: 'Sep 27'
  },
  time: '3 PM–6 PM',
  venueName: 'Peridia Golf & Country Club',
  venueUrl: 'https://www.peridiagcc.net/',
  mapUrl: PERIDIA_MAP_URL,
  city: 'Bradenton, Florida',
  thumbnail: PERIDIA_LOGO,
  markerBackingClass: 'bg-[var(--vu-cream)]',
  swatchClass: 'bg-[#556b3c] border-[var(--vu-gold)] shadow-[inset_0_0_0_4px_#27351c]'
}, {
  date: {
    weekday: 'Sun',
    monthDay: 'Oct 11'
  },
  time: '2 PM–6 PM',
  venueName: 'American Legion Post 273',
  venueUrl: 'https://amleg273.com/',
  mapUrl: AMERICAN_LEGION_MAP_URL,
  city: 'Madeira Beach, Florida',
  thumbnail: AMERICAN_LEGION_LOGO,
  markerBackingClass: 'bg-[var(--vu-cream)]',
  markerLabel: 'Post 273',
  swatchClass: 'bg-[var(--vu-navy)] border-[var(--vu-gold)] shadow-[inset_0_0_0_4px_var(--vu-cream)]'
}, {
  date: {
    weekday: 'Sat',
    monthDay: 'Oct 24'
  },
  time: '7 PM–11 PM',
  venueName: 'Twisted Tiki',
  venueUrl: 'https://www.twistedtikistpetebeach.com',
  mapUrl: TWISTED_TIKI_MAP_URL,
  city: 'St. Pete Beach, Florida',
  thumbnail: TWISTED_TIKI_LOGO,
  markerBackingClass: 'bg-[var(--vu-navy)]',
  swatchClass: 'bg-[var(--vu-red)] border-[var(--vu-gold)] shadow-[inset_0_0_0_4px_var(--vu-navy)]'
}, {
  date: {
    weekday: 'Fri',
    monthDay: 'Nov 6'
  },
  time: '7 PM–11 PM',
  venueName: 'Twisted Tiki',
  venueUrl: 'https://www.twistedtikistpetebeach.com',
  mapUrl: TWISTED_TIKI_MAP_URL,
  city: 'St. Pete Beach, Florida',
  thumbnail: TWISTED_TIKI_LOGO,
  markerBackingClass: 'bg-[var(--vu-navy)]',
  swatchClass: 'bg-[var(--vu-red)] border-[var(--vu-gold)] shadow-[inset_0_0_0_4px_var(--vu-navy)]'
}, {
  date: {
    weekday: 'Fri',
    monthDay: 'Nov 13'
  },
  time: '6 PM–10 PM',
  venueName: 'American Legion Post 273',
  venueUrl: 'https://amleg273.com/',
  mapUrl: AMERICAN_LEGION_MAP_URL,
  city: 'Madeira Beach, Florida',
  thumbnail: AMERICAN_LEGION_LOGO,
  markerBackingClass: 'bg-[var(--vu-cream)]',
  markerLabel: 'Post 273',
  swatchClass: 'bg-[var(--vu-navy)] border-[var(--vu-gold)] shadow-[inset_0_0_0_4px_var(--vu-cream)]'
}, {
  date: {
    weekday: 'Fri',
    monthDay: 'Dec 5'
  },
  time: '7 PM–10 PM',
  venueName: "Mastry's Brewing Co.",
  venueUrl: 'https://mastrysbrewingco.com/events',
  mapUrl: MASTRYS_MAP_URL,
  city: 'St. Pete Beach, Florida',
  thumbnail: MASTRYS_LOGO,
  markerBackingClass: 'bg-[var(--vu-navy)]',
  swatchClass: 'bg-[var(--vu-navy)] border-[var(--vu-gold)] shadow-[inset_0_0_0_4px_var(--vu-black)]'
}, {
  date: {
    weekday: 'Sat',
    monthDay: 'Dec 26'
  },
  time: '7 PM–11 PM',
  venueName: 'Twisted Tiki',
  venueUrl: 'https://www.twistedtikistpetebeach.com',
  mapUrl: TWISTED_TIKI_MAP_URL,
  city: 'St. Pete Beach, Florida',
  thumbnail: TWISTED_TIKI_LOGO,
  markerBackingClass: 'bg-[var(--vu-navy)]',
  swatchClass: 'bg-[var(--vu-red)] border-[var(--vu-gold)] shadow-[inset_0_0_0_4px_var(--vu-navy)]'
}, {
  date: {
    weekday: 'Sat',
    monthDay: 'Jan 30'
  },
  time: '7 PM–11 PM',
  venueName: 'Twisted Tiki',
  venueUrl: 'https://www.twistedtikistpetebeach.com',
  mapUrl: TWISTED_TIKI_MAP_URL,
  city: 'St. Pete Beach, Florida',
  thumbnail: TWISTED_TIKI_LOGO,
  markerBackingClass: 'bg-[var(--vu-navy)]',
  swatchClass: 'bg-[var(--vu-red)] border-[var(--vu-gold)] shadow-[inset_0_0_0_4px_var(--vu-navy)]'
}, {
  date: {
    weekday: 'Sat',
    monthDay: 'Feb 27'
  },
  time: '7 PM–11 PM',
  venueName: 'Twisted Tiki',
  venueUrl: 'https://www.twistedtikistpetebeach.com',
  mapUrl: TWISTED_TIKI_MAP_URL,
  city: 'St. Pete Beach, Florida',
  thumbnail: TWISTED_TIKI_LOGO,
  markerBackingClass: 'bg-[var(--vu-navy)]',
  swatchClass: 'bg-[var(--vu-red)] border-[var(--vu-gold)] shadow-[inset_0_0_0_4px_var(--vu-navy)]'
}, {
  date: {
    weekday: 'Sat',
    monthDay: 'Mar 6'
  },
  time: 'Time TBA',
  venueName: 'Private Event',
  venueUrl: '',
  mapUrl: '',
  city: '',
  thumbnail: null,
  markerBackingClass: '',
  swatchClass: '',
  isPrivate: true
}];
function PrivateEventCard({
  show,
  index
}: {
  show: Show;
  index: number;
}) {
  return <motion.article key={`private-${show.date.monthDay}-${index}`} initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-40px'
  }} transition={{
    duration: 0.45,
    delay: index * 0.08
  }} className="group flex w-full overflow-hidden border-2 border-[var(--vu-gold)]/50 bg-[var(--vu-cream)]/90 text-[var(--vu-black)] shadow-[5px_5px_0_0_var(--vu-gold)]/30" data-id="element-90" data-mp="5wv31kpmm6a5">
      {/* Date block — gold background to distinguish from public gigs */}
      <div className="flex w-[29%] min-w-[88px] flex-col justify-center border-r-2 border-dashed border-[var(--vu-gold)]/75 bg-gradient-to-b from-[var(--vu-gold)] to-[#c8922a] px-2 py-5 text-center sm:w-[24%] sm:min-w-[142px] sm:px-5" data-id="element-91" data-mp="ks1927oq253h">
        <span className="font-cond text-[10px] font-semibold uppercase tracking-[0.2em] text-[var(--vu-black)]/70 sm:text-xs" data-id="element-92" data-mp="18iwtgjquly0p">
          {show.date.weekday}
        </span>
        <span className="mt-1 font-display text-xl uppercase leading-[0.9] text-[var(--vu-black)] sm:text-3xl" data-id="element-93" data-mp="1n65dma24xdot">
          {show.date.monthDay}
        </span>
      </div>

      {/* Content — no venue link, no directions */}
      <div className="flex min-w-0 flex-1 items-center gap-4 px-3 py-5 sm:gap-7 sm:px-6" data-id="element-94" data-mp="1d8h76mv62hqt">
        <div className="min-w-0 flex-1" data-id="element-95" data-mp="1i6sg8vdn0o7z">
          <div className="font-display text-2xl italic uppercase leading-none text-[var(--vu-gold)] sm:text-3xl" data-id="element-96" data-mp="1i5hbotcdbcft">
            Private Event
          </div>
          <div className="mt-3 space-y-1 font-cond text-[11px] uppercase tracking-[0.11em] text-[var(--vu-black)]/70 sm:text-xs" data-id="element-97" data-mp="188mh2lj7tw6t">
            <p className="flex items-center gap-2" data-id="element-98" data-mp="uij1ueir72qv">
              <ClockIcon className="h-3.5 w-3.5 shrink-0 text-[var(--vu-gold)]" aria-hidden="true" data-id="element-99" data-mp="zgkh0od26hx2" />
              {show.time}
            </p>
            <p className="flex items-center gap-2" data-id="element-100" data-mp="kkbkhukjyioc">
              <LockIcon className="h-3.5 w-3.5 shrink-0 text-[var(--vu-gold)]" aria-hidden="true" data-id="element-101" data-mp="pidehajio2el" />
              Invited guests only
            </p>
          </div>
        </div>

        {/* Icon badge instead of venue logo */}
        <div className="flex shrink-0 flex-col items-center" data-id="element-102" data-mp="10y9jr8luzd80">
          <span className="flex h-20 w-20 items-center justify-center rounded-2xl border-2 border-[var(--vu-gold)]/60 bg-gradient-to-br from-[var(--vu-gold)]/20 to-[var(--vu-gold)]/5 sm:h-24 sm:w-24" data-id="element-103" data-mp="10wyk9kzg4rmp">
            <PartyPopperIcon className="h-9 w-9 text-[var(--vu-gold)] sm:h-11 sm:w-11" data-id="element-104" data-mp="r2ziin3ab9va" />
          </span>
        </div>
      </div>
    </motion.article>;
}
function PublicShowCard({
  show,
  index
}: {
  show: Show;
  index: number;
}) {
  return <motion.article key={`${show.venueName}-${show.date.weekday}-${index}`} initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-40px'
  }} transition={{
    duration: 0.45,
    delay: index * 0.08
  }} className="group flex w-full overflow-hidden border-2 border-[var(--vu-gold)]/65 bg-[var(--vu-cream)] text-[var(--vu-black)] shadow-[5px_5px_0_0_var(--vu-navy)] transition-all duration-300 ease-out hover:-translate-y-1 hover:shadow-[0_0_0_1px_var(--vu-gold),0_12px_24px_rgba(224,163,37,0.22)]" data-id="element-105" data-mp="d8fdxazyiox9">
      <div className="flex w-[29%] min-w-[88px] flex-col justify-center border-r-2 border-dashed border-[var(--vu-gold)]/75 bg-[var(--vu-navy)] px-2 py-5 text-center sm:w-[24%] sm:min-w-[142px] sm:px-5" data-id="element-106" data-mp="3ubunfln7kva7">
        <span className="font-cond text-[10px] font-semibold uppercase tracking-[0.2em] text-[var(--vu-gold)] sm:text-xs" data-id="element-107" data-mp="31nfl9zp6e7ga">
          {show.date.weekday}
        </span>
        <span className="mt-1 font-display text-xl uppercase leading-[0.9] text-[var(--vu-cream)] sm:text-3xl" data-id="element-108" data-mp="36jw54hpcdznk">
          {show.date.monthDay}
        </span>
      </div>

      <div className="flex min-w-0 flex-1 items-center gap-4 px-3 py-5 sm:gap-7 sm:px-6" data-id="element-109" data-mp="3gdd2fvootwvz">
        <div className="min-w-0 flex-1" data-id="element-110" data-mp="2ivmr41ydeg6z">
          <a href={show.venueUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 rounded-sm font-display text-2xl uppercase leading-none text-[var(--vu-navy)] transition-colors hover:text-[var(--vu-red)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-3 focus-visible:outline-[var(--vu-red)] sm:text-3xl" data-id="element-111" data-mp="2iule3rxsnjmm">
            <span className="truncate" data-id="element-112" data-mp="3vaju85agvzn5">{show.venueName}</span>
            <ExternalLinkIcon className="h-4 w-4 shrink-0 text-[var(--vu-red)] sm:h-5 sm:w-5" aria-hidden="true" data-id="element-113" data-mp="3v7xkq040na2a" />
          </a>
          <div className="mt-3 space-y-1 font-cond text-[11px] uppercase tracking-[0.11em] text-[var(--vu-black)]/70 sm:text-xs" data-id="element-114" data-mp="33im2sq86mqde">
            <p className="flex items-center gap-2" data-id="element-115" data-mp="37jnv0n3om25v">
              <ClockIcon className="h-3.5 w-3.5 shrink-0 text-[var(--vu-red)]" aria-hidden="true" data-id="element-116" data-mp="3cb5xxgp9mcth" />
              {show.time}
            </p>
            <p className="flex items-center gap-2" data-id="element-117" data-mp="2fs8dh7gzf5mi">
              <MapPinIcon className="h-3.5 w-3.5 shrink-0 text-[var(--vu-red)]" aria-hidden="true" data-id="element-118" data-mp="2juv7nf14l2mv" />
              {show.city}
            </p>
          </div>
        </div>

        <a href={show.mapUrl} target="_blank" rel="noopener noreferrer" className="group/map flex shrink-0 flex-col items-center rounded-sm transition-transform duration-300 ease-out hover:scale-105 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-3 focus-visible:outline-[var(--vu-red)]" aria-label={`Get directions to ${show.venueName}`} data-id="element-119" data-mp="2cakl9bs1m7dg">
          <span className="relative block rounded-2xl hover:shadow-[0_0_0_2px_var(--vu-gold),0_0_16px_rgba(224,163,37,0.55)] group-hover/map:shadow-[0_0_0_2px_var(--vu-gold),0_0_16px_rgba(224,163,37,0.55)]" data-id="element-120" data-mp="1olrm76g4jjem">
            <span className={`block h-20 w-20 overflow-hidden rounded-2xl border-2 border-[var(--vu-gold)] sm:h-24 sm:w-24 ${show.markerBackingClass}`} data-id="element-121" data-mp="1flcyy1jlnu8h">
              <span className={`absolute inset-0 rounded-2xl ${show.swatchClass}`} aria-hidden="true" data-id="element-122" data-mp="1anuo25m0v4xu" />
              {show.thumbnail && <img src={show.thumbnail} alt={`${show.venueName} venue logo`} className="relative z-10 h-full w-full object-contain p-0.5" onError={event => {
              event.currentTarget.style.display = 'none';
            }} data-id="element-123" data-mp="vz1mlrdfm2tt" />}
            </span>
            <span className="absolute -bottom-1.5 -right-1.5 z-20 flex h-6 w-6 items-center justify-center rounded-full border border-[var(--vu-cream)] bg-[var(--vu-black)] text-[var(--vu-gold)] shadow-sm sm:h-7 sm:w-7" data-id="element-124" data-mp="1epsrogqdz72e">
              <MapPinIcon className="h-3.5 w-3.5 sm:h-4 sm:w-4" aria-hidden="true" data-id="element-125" data-mp="150j2b8mxg2hz" />
            </span>
          </span>
          {show.markerLabel && <span className="mt-1.5 font-cond text-[9px] uppercase tracking-[0.15em] text-[var(--vu-navy)]" data-id="element-126" data-mp="19wzp9zie4ath">
              {show.markerLabel}
            </span>}
        </a>
      </div>
    </motion.article>;
}
export function Shows() {
  return <section id="shows" className="relative w-full overflow-hidden bg-[var(--vu-black)] px-5 py-20 grain" data-id="element-127" data-mp="3n4qvea8qkpk0">
      <div className="relative z-10 mx-auto max-w-4xl text-center" data-id="element-128" data-mp="3i664x2jadk8r">
        <header className="relative overflow-hidden rounded-2xl border-2 border-[var(--vu-gold)]/75 bg-[var(--vu-black)] shadow-[6px_6px_0_0_var(--vu-navy)]" data-id="element-129" data-mp="qhaib40lznz">
          <img src="https://cdn.magicpatterns.com/uploads/dnMcD2rKQg8oCV2tvhE7Kc/VU_ConcertStage_Gemini.png" alt="Virtually Unknown performing together under concert stage lights" className="block aspect-video w-full object-contain" data-id="element-130" data-mp="3ryv716sy5lrf" />
          <div className="absolute inset-x-0 top-0 h-[43%] bg-gradient-to-b from-[var(--vu-black)] via-[var(--vu-black)]/90 to-transparent" data-id="element-131" data-mp="3d5i5bsgzrv2x" />
          <div className="absolute inset-x-0 top-0 z-10 flex h-[38%] flex-col items-center justify-start px-4 pt-3 sm:pt-5" data-id="element-132" data-mp="sgueslmbes9w">
            <p className="mb-1 font-cond text-[10px] uppercase tracking-[0.4em] text-[var(--vu-gold)] [text-shadow:0_2px_4px_rgba(0,0,0,0.95)] sm:mb-2 sm:text-xs" data-id="element-133" data-mp="of0hmnbbw6eh">
              On The Marquee
            </p>
            <h2 className="font-display text-3xl uppercase leading-none text-[var(--vu-cream)] [text-shadow:0_3px_8px_rgba(0,0,0,0.95)] sm:text-5xl" data-id="element-134" data-mp="1ns2cn8fzvz0d">
              Upcoming Shows
            </h2>
            <BadgeDivider label="♬" data-id="element-135" data-mp="1xqj5yc2eoppl" />
          </div>
        </header>

        <div className="mt-8 space-y-5 text-left" data-id="element-136" data-mp="22pcia15yiao6">
          {SHOWS.map((show, index) => show.isPrivate ? <PrivateEventCard key={`private-${show.date.monthDay}-${index}`} show={show} index={index} data-id="element-137" data-mp="26p3i0udgo14u" /> : <PublicShowCard key={`${show.venueName}-${show.date.weekday}-${index}`} show={show} index={index} data-id="element-138" data-mp="2bj7rple42n9m" />)}
        </div>

        <p className="mt-6 font-cond text-xs uppercase tracking-[0.2em] text-[var(--vu-cream)]/45" data-id="element-139" data-mp="2lg3r91m17z21">
          Full fall/winter schedule — more being added as they're booked
        </p>

        <div className="mt-10 border-2 border-[var(--vu-gold)]/40 bg-[var(--vu-navy)] p-8" data-id="element-140" data-mp="eqs8b60ghuoz">
          <PartyPopperIcon className="mx-auto h-8 w-8 text-[var(--vu-gold)]" data-id="element-141" data-mp="9s8nxa1igqyq" />
          <p className="mt-3 font-body text-base leading-relaxed text-[var(--vu-cream)]/85" data-id="element-142" data-mp="9ubo2mwdo0h6">
            We also play <strong className="text-[var(--vu-cream)]" data-id="element-143" data-mp="3vz6wo5wvrsg3">private events, weddings, and corporate parties.</strong>{' '}
            Reach out and we'll put together a quote for your date.
          </p>
          <div className="mt-6 flex flex-wrap justify-center gap-4" data-id="element-144" data-mp="siglzdqcsr82">
            <a href="mailto:nicksettemusic@gmail.com" className="inline-flex items-center gap-2 border-2 border-[var(--vu-black)] bg-[var(--vu-gold)] px-7 py-3 font-display uppercase tracking-wider text-[var(--vu-black)] shadow-[4px_4px_0_0_var(--vu-black)] transition-all hover:translate-x-[3px] hover:translate-y-[3px] hover:shadow-[1px_1px_0_0_var(--vu-black)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-[var(--vu-gold)]" data-id="element-145" data-mp="sj8icqrrysze">
              <MailIcon className="h-4 w-4" data-id="element-146" data-mp="35riyzx5fyttx" />
              Booking Inquiry
            </a>
          </div>
        </div>
      </div>
    </section>;
}